import React from 'react';

import { useUserContext } from '@context/UserContext';
import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';

import { ECartPageState, useCartPageContext } from '../../context';
import { EBenefitState } from '../../model';
import { getDeliveryBenefit } from '../../utils';

import { LoyaltyFreeDeliveryItem } from './LoyaltyFreeDeliveryItem/LoyaltyFreeDeliveryItem';
import { StyledLoyaltyWrapper } from './styled';
import { shouldBeDeliveryBenefitDisplayed } from './utils';

export const LoyaltyFreeDeliveryItemWrapper: ReactFCV = () => {
  const {
    state: {
      benefits: { loyalties },
      pricesSummary: { priceItemSummary },
    },
    actions: { setCartPageState },
    settings: { orderPriceActivationThreshold, isDeliveryBenefitEnabled },
  } = useCartPageContext();

  const {
    state: { isLogged, isSubscribed },
  } = useUserContext();

  const freeDeliveryBenefit = getDeliveryBenefit(loyalties);

  if (!shouldBeDeliveryBenefitDisplayed(freeDeliveryBenefit, isDeliveryBenefitEnabled)) {
    return null;
  }

  return (
    <>
      <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
      <StyledLoyaltyWrapper data-testid="loyalty-free-delivery-item-wrapper">
        <LoyaltyFreeDeliveryItem
          isActive={freeDeliveryBenefit?.state === EBenefitState.ACTIVE}
          isRegistered={isLogged}
          isSubscribed={isSubscribed}
          price={priceItemSummary}
          onClick={() => setCartPageState(ECartPageState.BENEFIT_FREE_DELIVERY)}
          activationThreshold={
            freeDeliveryBenefit ? freeDeliveryBenefit.activationThreshold : orderPriceActivationThreshold
          }
          {...freeDeliveryBenefit}
        />
      </StyledLoyaltyWrapper>
    </>
  );
};
